<div class="custom-personal-details-form d-flex flex-column">
    <div class="personal-header">
        {{ 'mycompany.title' | cxTranslate}}
    </div>
    <div class="personal-header-three">
        {{ 'mycompany.orgId' | cxTranslate}}
    </div>
    <div class="personal-header-four">
        {{ organizationData.orgId }}
    </div>
    <div class="personal-header-three">
        {{ 'mycompany.orgName' | cxTranslate}}
    </div>
    <div class="personal-header-four">
        {{  organizationData.orgName }}
    </div>
    <div class="personal-header-three">
        {{ 'mycompany.billingAddress' | cxTranslate }}
    </div>
    <div class="personal-header-four">
        {{ organizationData.orgAddress}}
    </div>
</div>